import { RouteConfig } from '../types';
import * as Components from '../lazyComponents';
import { Navigate } from 'react-router-dom';
import { MarketingTabsGhl } from '@/features/layout/components/MarketingTabsGhl';

export const agencyRoutes: RouteConfig[] = [
  {
    path: '/agencia/dashboard',
    element: <Components.AgencyDashboardPage />,
    roles: ['AGENCY_ADMIN'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    // #790 #792 — Theme Options (Apariencia y Configuración)
    path: '/agencia/apariencia',
    element: <Components.AgencyThemeOptionsPage />,
    roles: ['AGENCY_ADMIN'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    path: '/agencia/inventario',
    element: <Components.InventoryPage />,
    roles: ['AGENCY_ADMIN'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    path: '/agencia/propiedades',
    element: <Navigate to="/agencia/inventario" replace />,
    roles: ['AGENCY_ADMIN'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    path: '/agencia/inventario/propiedades/agregar',
    element: <Components.CreatePropertyPage />,
    roles: ['AGENCY_ADMIN'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    path: '/agencia/propiedades/:id/editar',
    element: <Components.AgencyEditPropertyPage />,
    roles: ['AGENCY_ADMIN'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    path: '/agencia/agentes',
    element: <Components.SharedAgentsPage />,
    roles: ['AGENCY_ADMIN'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    path: '/agencia/agentes/agregar',
    element: <Components.AgencyAddAgentPage />,
    roles: ['AGENCY_ADMIN'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    path: '/agencia/agentes/nuevo',
    element: <Components.AgencyAddAgentPage />,
    roles: ['AGENCY_ADMIN'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    path: '/agencia/agentes/:id/editar',
    element: <Components.AgencyEditAgentPage />,
    roles: ['AGENCY_ADMIN'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    path: '/agencia/clientes',
    element: <Components.SharedClientsPage />,
    roles: ['AGENCY_ADMIN', 'AGENCY_AGENT_USER'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    path: '/agencia/clientes/agregar',
    element: <Components.CreateClientPage />,
    roles: ['AGENCY_ADMIN', 'AGENCY_AGENT_USER'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    path: '/agencia/clientes/nuevo',
    element: <Components.CreateClientPage />,
    roles: ['AGENCY_ADMIN', 'AGENCY_AGENT_USER'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    path: '/agencia/clientes/:id/editar',
    element: <Components.EditClientPage />,
    roles: ['AGENCY_ADMIN'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    path: '/agencia/clientes/papelera',
    element: <Components.ClientsTrashPage />,
    roles: ['AGENCY_ADMIN'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    path: '/agencia/cotizaciones',
    element: <Components.AgencyQuotesPage />,
    roles: ['AGENCY_ADMIN'],
    requiresAuth: true,
    requiresLayout: true,
  },
  // #882 — plantillas de WhatsApp (escribir fuera de la ventana de 24h)
  {
    path: '/agencia/whatsapp-plantillas',
    element: <Components.WhatsappTemplatesPage />,
    roles: ['AGENCY_ADMIN', 'BROKER_MANAGER_ADMIN'],
    requiresAuth: true,
    requiresLayout: true,
  },
  // #870 — gestion de embudos configurables (crear campana/proyecto con etapas propias)
  {
    path: '/agencia/crm/embudos',
    element: <Components.AgencyPipelinesPage />,
    roles: ['AGENCY_ADMIN', 'BROKER_MANAGER_ADMIN'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    path: '/agencia/crm',
    element: <Components.AgencyCrmPage />,
    roles: ['AGENCY_ADMIN', 'BROKER_MANAGER_ADMIN'],
    requiresAuth: true,
    requiresLayout: true,
  },
  // LB-12 Builder B (2026-06-03) — Lead list page con Kanban + BulkToolbar
  {
    path: '/agencia/crm/leads',
    title: 'Leads',
    element: <Components.AgencyCrmLeadsListPage />,
    roles: ['AGENCY_ADMIN', 'BROKER_MANAGER_ADMIN', 'AGENCY_AGENT_USER'],
    requiresAuth: true,
    requiresLayout: true,
  },
  // GHL 7.7 — campos personalizados (mismos roles que escriben en crm/custom-fields)
  {
    path: '/agencia/crm/campos',
    element: <Components.AgencyCrmCamposPage />,
    roles: ['AGENCY_ADMIN', 'BROKER_MANAGER_ADMIN'],
    requiresAuth: true,
    requiresLayout: true,
  },
  // LB-12 Builder A — Lead detail page con tabs + audit timeline + tag picker
  {
    path: '/agencia/crm/leads/:id',
    element: <Components.AgencyCrmLeadDetailPage />,
    roles: ['AGENCY_ADMIN', 'BROKER_MANAGER_ADMIN', 'AGENCY_AGENT_USER'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    path: '/agencia/proyectos',
    element: <Components.AgencyProjectsPage />,
    roles: ['AGENCY_ADMIN'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    path: '/agencia/proyectos/nuevo',
    element: <Components.AgencyCreateProjectPage />,
    roles: ['AGENCY_ADMIN'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    path: '/agencia/proyectos/:id',
    element: <Components.AgencyProjectDetailPage />,
    roles: ['AGENCY_ADMIN'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    path: '/agencia/erp',
    element: <Components.AgencyErpPage />,
    roles: ['AGENCY_ADMIN', 'ACCOUNTING_TEAM'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    path: '/agencia/erp/facturas/nueva',
    element: <Components.AgencyCreateInvoicePage />,
    roles: ['AGENCY_ADMIN', 'ACCOUNTING_TEAM'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    path: '/agencia/erp/wizard',
    element: <Components.InvoiceWizardPage />,
    roles: ['AGENCY_ADMIN', 'ACCOUNTING_TEAM', 'BROKER_MANAGER_ADMIN', 'PROJECT_DEVELOPER_ADMIN'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    path: '/agencia/documentos',
    element: <Components.AgencyDocumentsPage />,
    roles: ['AGENCY_ADMIN'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    path: '/agencia/documentos/nuevo',
    element: <Components.AgencyCreateDocumentPage />,
    roles: ['AGENCY_ADMIN'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    path: '/agencia/dgii',
    element: <Components.DgiiPage />,
    roles: ['AGENCY_ADMIN', 'ACCOUNTING_TEAM'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    path: '/agencia/tareas',
    element: <Components.AgencyTasksPage />,
    roles: ['AGENCY_ADMIN'],
    requiresAuth: true,
    requiresLayout: true,
  },
  // Redirect antiguo Financiero a ERP
  {
    path: '/agencia/financiero',
    element: <Navigate to="/agencia/erp" replace />,
    roles: ['AGENCY_ADMIN'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    path: '/agencia/financiero/registrar-ingreso',
    element: <Components.AgencyRegisterIncomePage />,
    roles: ['AGENCY_ADMIN'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    path: '/agencia/redes',
    element: <Components.AgencyMarketingPage />,
    roles: [
      'AGENCY_ADMIN',
      'BROKER_MANAGER_ADMIN',
      'AGENCY_AGENT_USER',
      'ACCOUNTING_TEAM',
    ],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    path: '/agencia/redes/publicaciones',
    element: (
      <MarketingTabsGhl>
        <Components.AgencyMarketingPublicationsPage />
      </MarketingTabsGhl>
    ),
    roles: ['AGENCY_ADMIN', 'AGENCY_AGENT_USER'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    // GH#1632 — composer de un solo paso (paridad GHL). Antes: 404.
    path: '/agencia/redes/publicaciones/nuevo',
    element: <Components.AgencyMarketingPostComposerPage />,
    roles: ['AGENCY_ADMIN', 'AGENCY_AGENT_USER'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    // GH#1632 — Editar publicación. Antes: 404 (la ruta no estaba declarada).
    path: '/agencia/redes/publicaciones/:id/editar',
    element: <Components.AgencyPublicacionDetallePage />,
    roles: ['AGENCY_ADMIN', 'AGENCY_AGENT_USER'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    // GH#1632 — Duplicar publicación. Antes: 404.
    path: '/agencia/redes/publicaciones/:id/duplicar',
    element: <Components.AgencyPublicacionDetallePage />,
    roles: ['AGENCY_ADMIN', 'AGENCY_AGENT_USER'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    // GH#1632 — Ver publicación. Antes: 404. (Dinámica: va después de /nuevo.)
    path: '/agencia/redes/publicaciones/:id',
    element: <Components.AgencyPublicacionDetallePage />,
    roles: ['AGENCY_ADMIN', 'AGENCY_AGENT_USER'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    path: '/agencia/redes/ads',
    // Plan Ads Watley: es el destino de la pestaña «Administrador de anuncios», así que lleva las pestañas.
    element: (
      <MarketingTabsGhl>
        <Components.AgencyMarketingAdsPage />
      </MarketingTabsGhl>
    ),
    // ACCOUNTING_TEAM afuera (decisión CTO, 23-oct): google-ads.controller y meta-ads.controller no le
    // dan ninguna ruta, ni de lectura; entraba a una pantalla que le respondía 403.
    roles: ['AGENCY_ADMIN', 'BROKER_MANAGER_ADMIN'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    path: '/agencia/redes/automatizacion',
    element: <Components.AgencyMarketingAutomationPage />,
    roles: ['AGENCY_ADMIN'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    path: '/agencia/redes/marketplace',
    element: <Components.AgencyMarketingMarketplacePage />,
    roles: ['AGENCY_ADMIN'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    path: '/agencia/redes/email',
    element: <Components.AgencyMarketingEmailPage />,
    roles: ['AGENCY_ADMIN'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    path: '/agencia/redes/seo',
    element: <Components.AgencyMarketingSeoPage />,
    roles: ['AGENCY_ADMIN', 'BROKER_MANAGER_ADMIN'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    // Wizard genérico (Email/Redes, #1249). Sólo AGENCY_ADMIN: el constructor
    // de anuncios tiene su propia ruta abajo, para no abrir este wizard a
    // BROKER_MANAGER_ADMIN.
    path: '/agencia/redes/campanas/crear',
    element: <Components.AgencyCreateCampaignPage />,
    roles: ['AGENCY_ADMIN'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    // Constructor real de campañas de Meta Ads. El backend autoriza crear
    // campaña a AGENCY_ADMIN y BROKER_MANAGER_ADMIN (contrato ATLAS #1639).
    path: '/agencia/redes/campanas/crear/anuncios',
    element: <Components.MetaAdsCampaignBuilderPage />,
    roles: ['AGENCY_ADMIN', 'BROKER_MANAGER_ADMIN'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    path: '/agencia/reportes',
    element: <Components.AgencyReportsPage />,
    roles: ['AGENCY_ADMIN'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    // GH#1912 — Informes › Atribución (la API de agency/reports/atribucion ya respondía; faltaba la pantalla).
    path: '/agencia/reportes/atribucion',
    element: <Components.AgencyAtribucionPage />,
    roles: ['AGENCY_ADMIN'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    path: '/agencia/reportes/nuevo',
    element: <Components.AgencyCreateReportPage />,
    roles: ['AGENCY_ADMIN'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    path: '/agencia/contactos',
    element: <Components.ContactsPage />,
    roles: ['AGENCY_ADMIN'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    path: '/agencia/inbox',
    element: <Components.InboxPage />,
    roles: ['AGENCY_ADMIN'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    // Ola 2 GHL #5 — Mi Agenda (vista lista de citas).
    path: '/agencia/agenda',
    element: <Components.AgendaPage />,
    roles: ['AGENCY_ADMIN', 'BROKER_MANAGER_ADMIN'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    // Ola 2 GHL #6 — Campañas de Email (marketing a segmentos).
    path: '/agencia/email-campaigns',
    element: (
      <MarketingTabsGhl>
        <Components.EmailCampaignsPage />
      </MarketingTabsGhl>
    ),
    // GH#1631: = ROLES_EMAIL_CAMPAIGNS (roles del controller). BROKER_MANAGER_ADMIN
    // entraba y recibia 403 en todo: la lista, crear y enviar.
    roles: ['AGENCY_ADMIN'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    // GH#1631 — el borrador nace en «Nuevo» y se edita acá.
    path: '/agencia/email-campaigns/:id/editar',
    element: <Components.EditorCampanaEmailPage />,
    roles: ['AGENCY_ADMIN'], // = ROLES_EMAIL_CAMPAIGNS
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    // GHL 2.8 — detalle de una campaña enviada.
    path: '/agencia/email-campaigns/:id',
    element: <Components.DetalleCampanaEmailPage />,
    roles: ['AGENCY_ADMIN'], // = ROLES_EMAIL_CAMPAIGNS
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    // Ola 2 GHL #8 — Secuencias de pipeline (drip automation).
    path: '/agencia/secuencias',
    element: <Components.SequencesPage />,
    roles: ['AGENCY_ADMIN', 'BROKER_MANAGER_ADMIN'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    // Ola 2 GHL #9 — Enlaces de pago (PayPal.me).
    path: '/agencia/enlaces-pago',
    title: 'Enlaces de cobro',
    element: <Components.PaymentLinksPage />,
    roles: ['AGENCY_ADMIN', 'BROKER_MANAGER_ADMIN'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    // #874 — Calendarios de reserva (tipos agendables + link público tipo Calendly).
    path: '/agencia/calendarios',
    element: <Components.CalendarSettingsPage />,
    roles: ['AGENCY_ADMIN', 'BROKER_MANAGER_ADMIN'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    // #873 — Widget de chat embebible (snippet para sitios externos).
    path: '/agencia/widget',
    element: <Components.WidgetEmbedPage />,
    roles: ['AGENCY_ADMIN', 'BROKER_MANAGER_ADMIN'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    // Ola 2 GHL #11 — Config del Asistente IA (self-service).
    path: '/agencia/asistente-ia',
    element: <Components.AiSettingsPage />,
    roles: ['AGENCY_ADMIN', 'BROKER_MANAGER_ADMIN'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    // #876 — Publicidad (Meta). Qué anuncio trae compradores, no cuál tiene clics.
    path: '/agencia/publicidad',
    element: (
      <MarketingTabsGhl>
        <Components.AdsPage />
      </MarketingTabsGhl>
    ),
    roles: ['AGENCY_ADMIN', 'BROKER_MANAGER_ADMIN'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    path: '/agencia/configuracion',
    title: 'Configuración',
    element: <Components.AgencySettingsPage />,
    roles: ['AGENCY_ADMIN'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    path: '/agencia/configuracion/planes',
    element: <Components.AgencyPlansPage />,
    roles: ['AGENCY_ADMIN'],
    requiresAuth: true,
    requiresLayout: true,
  },
  // Task #666 — Mi Suscripción (tenant-self billing dashboard)
  {
    path: '/agencia/configuracion/mi-suscripcion',
    title: 'Mi suscripción',
    element: <Components.MySubscriptionPage />,
    roles: ['AGENCY_ADMIN'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    // Tienda de addons — SOLO LECTURA: contratar espera la letra de billing de Randhy.
    path: '/agencia/configuracion/addons',
    title: 'Addons',
    element: <Components.AddonsStorePage />,
    roles: ['AGENCY_ADMIN'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    // UpgradeModal y UsageAlertBanner enlazan a «/addons», que no existía (404).
    path: '/addons',
    element: <Navigate to="/agencia/configuracion/addons" replace />,
    roles: ['AGENCY_ADMIN'],
    requiresAuth: true,
    requiresLayout: false,
  },
  // PB0-CAT4-52 (Multi-Site) — sitios ilimitados por tenant (v4.6)
  // SiteSwitcherDropdown ya enlaza a esta ruta — registrarla cierra el gap
  // de "page exists, no route consumer".
  {
    path: '/agencia/configuracion/sitios',
    element: <Components.SitesManagementPage />,
    roles: ['AGENCY_ADMIN'],
    requiresAuth: true,
    requiresLayout: true,
  },
  // Builder (E4)
  {
    path: '/agencia/builder',
    element: <Components.BuilderOverviewPage />,
    roles: ['AGENCY_ADMIN', 'PROJECT_DEVELOPER_ADMIN'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    path: '/agencia/builder/crear',
    element: <Components.BuilderTemplatePage />,
    roles: ['AGENCY_ADMIN', 'PROJECT_DEVELOPER_ADMIN'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    path: '/agencia/builder/personalizar',
    element: <Components.BuilderCustomizePage />,
    roles: ['AGENCY_ADMIN', 'PROJECT_DEVELOPER_ADMIN'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    path: '/agencia/builder/preview',
    element: <Components.BuilderPreviewPage />,
    roles: ['AGENCY_ADMIN', 'PROJECT_DEVELOPER_ADMIN'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    path: '/agencia/builder/publicar',
    element: <Components.BuilderPublishPage />,
    roles: ['AGENCY_ADMIN', 'PROJECT_DEVELOPER_ADMIN'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    path: '/agencia/builder/analytics',
    element: <Components.BuilderAnalyticsPage />,
    roles: ['AGENCY_ADMIN', 'PROJECT_DEVELOPER_ADMIN'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    path: '/agencia/builder/dominio',
    element: <Components.BuilderDomainPage />,
    roles: ['AGENCY_ADMIN', 'PROJECT_DEVELOPER_ADMIN'],
    requiresAuth: true,
    requiresLayout: true,
  },
  // G1 (2026-06-07) — Brand Kits manager (workspace surface SB)
  {
    path: '/agencia/builder/brand-kits',
    element: <Components.BuilderBrandKitsPage />,
    roles: ['AGENCY_ADMIN', 'PROJECT_DEVELOPER_ADMIN'],
    requiresAuth: true,
    requiresLayout: true,
  },
  // G2 (2026-06-07) — User Templates library (workspace surface SB)
  {
    path: '/agencia/builder/templates',
    element: <Components.BuilderTemplatesLibraryPage />,
    roles: ['AGENCY_ADMIN', 'PROJECT_DEVELOPER_ADMIN'],
    requiresAuth: true,
    requiresLayout: true,
  },
  // Fase 4 (2026-06-13) — Standards admin
  {
    path: '/agencia/builder/standards',
    element: <Components.BuilderStandardsPage />,
    roles: ['AGENCY_ADMIN', 'PROJECT_DEVELOPER_ADMIN'],
    requiresAuth: true,
    requiresLayout: true,
  },
  // GrapesJS visual editor for agency
  {
    path: '/agencia/builder/editor',
    element: <Components.WebpageBuilderPage />,
    roles: ['AGENCY_ADMIN', 'PROJECT_DEVELOPER_ADMIN'],
    requiresAuth: true,
    requiresLayout: false,
  },
  {
    path: '/agencia/builder/editor/:id',
    element: <Components.WebpageBuilderPage />,
    roles: ['AGENCY_ADMIN', 'PROJECT_DEVELOPER_ADMIN'],
    requiresAuth: true,
    requiresLayout: false,
  },
  // Templates (Unified - replaces Email Templates)
  {
    path: '/agencia/templates',
    element: <Components.TemplatesPage />,
    roles: ['AGENCY_ADMIN'],
    requiresAuth: true,
    requiresLayout: true,
  },
  // Redirect old email-templates route to unified templates
  {
    path: '/agencia/email-templates',
    element: <Navigate to="/agencia/templates" replace />,
    roles: ['AGENCY_ADMIN'],
    requiresAuth: true,
    requiresLayout: true,
  },
  // API Keys
  {
    path: '/agencia/api-keys',
    element: <Components.ApiKeysPage />,
    roles: ['AGENCY_ADMIN'],
    requiresAuth: true,
    requiresLayout: true,
  },
  // TASK #672-6 NetworkSettingsPage — owner-only network configuration
  // Owner check final via component-level useAuth (L1 stub; routing guard
  // restringe rol AGENCY_ADMIN, ownership real verifica useIsNetworkOwner).
  {
    path: '/network/:networkId/settings',
    element: <Components.NetworkSettingsPage />,
    roles: ['AGENCY_ADMIN', 'SUPER_ADMIN'],
    requiresAuth: true,
    requiresLayout: true,
  },

  // Task #677 — MLS connections UI (mapeo de campos + sandbox)
  // Backend gate (CheckAddonGuard + RequireAddon('mls_externo')) enforces
  // entitlement; routing only restricts role. Visual gate
  // RequireMlsAddonGate inside the page handles the upsell experience.
  {
    path: '/agencia/mls',
    element: <Components.MlsConnectionsPage />,
    roles: [
      'AGENCY_ADMIN',
      'SUPER_ADMIN',
      'BROKER_MANAGER_ADMIN',
      'PROJECT_DEVELOPER_ADMIN',
    ],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    path: '/agencia/mls/:id',
    element: <Components.MlsConnectionDetailPage />,
    roles: [
      'AGENCY_ADMIN',
      'SUPER_ADMIN',
      'BROKER_MANAGER_ADMIN',
      'PROJECT_DEVELOPER_ADMIN',
    ],
    requiresAuth: true,
    requiresLayout: true,
  },
  // Trust Badge — AGENCY_ADMIN solicita verificacion (envia documentos al SUPER_ADMIN)
  {
    path: '/agencia/trust-badge/request',
    element: <Components.TrustBadgeRequestVerificationPage />,
    roles: ['AGENCY_ADMIN'],
    requiresAuth: true,
    requiresLayout: true,
  },
  // Featured Listings — AGENCY_ADMIN gestion de promociones destacadas
  {
    path: '/agencia/featured-listings/my-active',
    element: <Components.FeaturedListingsMyActivePage />,
    roles: ['AGENCY_ADMIN'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    path: '/agencia/featured-listings/buy-promotion',
    element: <Components.FeaturedListingsBuyPromotionPage />,
    roles: ['AGENCY_ADMIN'],
    requiresAuth: true,
    requiresLayout: true,
  },
];
